<template>
  <div class="container">
    <div v-if="!isAuthLv1" class="row justify-content-center">
      <div class="col-md-12 mt-5 text-center">
        <h3>Unauthorized</h3>
        <p>You do not have permission to view this page.</p>
      </div>
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-md-12">
        <h5 class="mt-3">Check In:</h5>
        <div class="d-flex justify-content-center mb-5">
          <div class="input-group">
            <input
              @keyup.enter="checkinSearch"
              class="form-control"
              type="text"
              id="memberSearchInput"
              name="memberSearchInput"
              v-model="memberSearchInput"
              placeholder="Search member ID, name, or phone.."
              aria-label="Search member ID, name, or phone.."
              autocomplete="off"
              autofocus
            />
            <div class="input-group-append">
              <span
                class="input-group-text pl-4 pr-4"
                id="searchbtt"
                @click.prevent="checkinSearch"
              ><i
                  class="fas fa-search text-grey"
                  aria-hidden="true"
                ></i></span>
            </div>
          </div>
        </div>
        <div
          v-if="loadingSearch || loadingCheckin"
          class="text-center"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <transition name="slide-fade">
          <div
            class="memberchk col-md-12"
            v-if="memberCheckedObj"
          >
            <div>
              <b-jumbotron
                v-if="!loadingSearch && !loadingCheckin"
                :bg-variant="getMemberStatus"
                text-variant="white"
              >
                <template v-slot:header>{{ memberCheckedObj.cardid }} -
                  {{ memberCheckedObj.firstname }}
                  {{ memberCheckedObj.lastname }}</template>

                <template
                  v-slot:lead
                  v-if="isActivePackage"
                >
                  <div>
                    Package:
                    <strong>{{
                      getLocalPackageFull(memberPackageCheckedObj.package)
                    }}</strong>
                    <span
                      class="ml-1"
                      v-if="afterchk_session_use != null"
                    >
                      <strong>[{{ afterchk_session_use }} /
                        {{ afterchk_session_max }}]</strong>
                    </span>
                  </div>

                  <div>
                    Valid: From
                    <strong>{{
                        formatDateDisplayLocal(
                          memberPackageCheckedObj.activate_date
                        )
                      }}
                      to
                      {{
                        formatDateDisplayLocal(
                          memberPackageCheckedObj.expire_date
                        )
                      }}</strong>
                  </div>
                  <div>
                    Ref #:
                    <strong>{{ memberPackageCheckedObj.ref_number }}</strong>
                  </div>
                </template>
                <template
                  v-slot:lead
                  v-else-if="memberCheckedObj.memberpackage.length > 1"
                >
                  You have more than one packages, Please select
                </template>
                <template
                  v-slot:lead
                  v-else-if="
                    memberCheckedObj.memberpackage.length == 0 ||
                      isExpirePackage
                  "
                >
                  <center>Membership has Expired or Inactive</center>
                </template>

                <!-- If more than one package, show all options -->
                <!--<b-card-group
                  deck
                  v-if="
                    memberCheckedObj.memberpackage.length > 1 &&
                      memberPackageCheckedObj == null
                  "
                >-->
                <b-card-group
                  deck
                  v-if="hasMultiplePackages"
                >
                  <b-card
                    bg-variant="white"
                    text-variant="dark"
                    align="center"
                    v-for="item in memberCheckedObj.memberpackage"
                    :key="item.id"
                  >
                    <b-card-title>{{ item.package.fullname }} </b-card-title>
                    <b-card-text>
                      <small>Expire on: {{ item.expire_date }}</small></b-card-text>
                    <template v-slot:footer>
                      <b-button
                        variant="dark"
                        @click.prevent="performCheckin(item)"
                      >Check In</b-button>
                    </template>
                  </b-card>
                </b-card-group>

                <template v-if="schedules!=null && memberPackageCheckedObj.package.type=='CLS'">
                  <!--<table class="table table-light">
                    <tbody>

                      <tr
                        v-for="(item, index) in bookings"
                        :key="index"
                      >
                        <th scope="row">{{getTimeFromDateFormat(item.schedule.start_at)}} - {{getTimeFromDateFormat(item.schedule.end_at)}}</th>
                        <td>{{item.schedule.gclass.name}}</td>
                        <td><input
                            type="checkbox"
                            class="form-check-input checkinbox"
                            id="memberpackage_status"
                            :checked="(item.status=='SHOW')"
                            @click="checkin(item,item.memberpackage_id,$event)"
                          /></td>
                      </tr>
                    </tbody>
                  </table>-->
                  <!---------- Class Time table ------------>
                  <div class="card border-dark classcard">
                    <h5 class="card-header">
                      <span>{{ dow }} - {{ formatDateDisplayLocal(todaydate) }}</span>
                    </h5>
                    <div class="card-body">
                      <table
                        class="table table-sm"
                        v-if="schedules.length > 0"
                      >
                        <thead>
                          <tr>
                            <th scope="col">Time</th>
                            <th scope="col">Members</th>
                            <th scope="col">Class</th>
                            <th scope="col">Coach</th>
                            <th scope="col">Room</th>
                            <th scope="col">Booked</th>
                            <th
                              scope="col"
                              class="text-right"
                            >Check In</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in schedules"
                            :key="index"
                          >
                            <th scope="row">
                              {{ getTimeFromDateFormat(item.start_at) }} -
                              {{ getTimeFromDateFormat(item.end_at) }}
                            </th>
                            <td>
                              {{ item.bookings != null ? item.bookings.length : 0 }}/{{ item.gclass.maxamount }}
                            </td>
                            <td>{{ item.gclass.name }}</td>
                            <td>{{ item.coach.nickname }}</td>
                            <td>{{ item.room.name }}</td>
                            <td>
                              <div
                                v-for="(bitem, bindex) in item.bookings"
                                :key="bindex"
                              >
                                <div v-if="bitem.member_id==memberCheckedObj.id">
                                  <span v-if="bitem.status=='BOOK'">Booked</span>
                                  <span
                                    v-else-if="bitem.status=='SHOW'"
                                    class="text-success"
                                  >Checked In</span>
                                  <span v-else>{{bitem.status}}</span>
                                </div>
                              </div>
                            </td>
                            <td class="text-right">
                              <input
                                type="checkbox"
                                class="form-check-input checkinbox"
                                id="memberpackage_status"
                                @click="classcheckin(item,$event)"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5
                        v-else
                        class="text-center nocls"
                      >-- No Class --</h5>
                    </div>
                  </div>
                  <!--------- End of Class time table ------>
                </template>
              </b-jumbotron>
            </div>
          </div>
        </transition>
        <div>
          <h5 v-if="hasMultipleResults">Search Result:</h5>
          <checkin-table
            v-if="hasMultipleResults"
            :memberResult="memberResult"
            v-on:member-checkin="verifyMemberPackage"
          ></checkin-table>
        </div>
        <h3
          v-if="hasNoResult"
          class="text-center red"
        >
          -- No Result is found --
        </h3>
        <!--<test-table></test-table>-->
      </div>
    </div>
  </div>
</template>
<script>
/* import DataTable from "laravel-vue-datatable";
import Vue from "vue";
Vue.use(DataTable); */
//import CheckinSearch from "./CheckinSearch.vue";
import CheckinTable from "./CheckinTable.vue";
import moment from "moment";
//import TestTable from "./TestTable.vue";
import {
  packageTypeFull,
  packageDurationFull,
  getPackageFull
} from "./../js/utils/datamanip.js";
import {
  formatDateDisplay,
  getTimeFromDateFormat
} from "./../js/utils/date.js";
import { isAuthLv1 } from "./../js/utils/global.js";
export default {
  components: {
    //CheckinSearch,
    CheckinTable,
    //TestTable,

    file: ""
  },
  data() {
    return {
      show: false,
      loadingSearch: false,
      loadingCheckin: false,
      hasMultipleResults: false,
      hasMultiplePackages: false,
      memberSearchInput: null,
      memberResult: null,
      memberCheckedObj: null,
      memberPackageCheckedObj: null,
      bookings: null,
      timeout: null,
      isActivePackage: false,
      hasNoResult: false,
      isExpirePackage: false,
      afterchk_session_use: null,
      afterchk_session_max: null,
      todaydate: moment().format("YYYY-MM-DD"),
      dow: moment().format("dddd")
      /*perPage: ["10", "25", "50"],
      columns: [
        {
          label: "ID",
          name: "id",
          filterable: true,
        },
        {
          label: "First Name",
          name: "firstname",
          filterable: true,
        },
        {
          label: "Email",
          name: "email",
          filterable: true,
        },
      ],*/
    };
  },
  computed: {
    isAuthLv1() {
      return isAuthLv1();
    },
    getMemberStatus() {
      if (this.isActivePackage) {
        return "success";
      } else if (this.hasMultiplePackages) {
        return "warning";
      } else {
        return "danger";
      }
    }
  },
  methods: {
    getTimeFromDateFormat,
    resetSearch() {
      this.memberCheckedObj = null;
      this.memberPackageCheckedObj = null;
      this.hasNoResult = false;

      this.hasMultipleResults = false;
      this.memberResult = null;
      this.hasMultiplePackages = false;
      this.isActivePackage = false;
      this.isExpirePackage = false;
      this.schedules = null;

      this.checkinloading = false;

      this.afterchk_session_use = null;
      this.afterchk_session_max = null;

      clearTimeout(this.timeout);
    },
    async checkinSearch() {
      //console.log(this.memberSearchInput);
      if (this.memberSearchInput == "" || this.memberSearchInput == null) {
        return false;
      }

      this.loadingSearch = true;
      //==== Reset Member Checkin Jumbotron
      this.resetSearch();

      //await axios.get("/sanctum/csrf-cookie");

      await axios
        .get("/api/members/find", {
          params: {
            keysearch: this.memberSearchInput
          }
        })
        .then(response => {
          this.memberSearchInput = null;
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          if (response.data.length == 0) {
            this.hasNoResult = true;
          } else if (response.data.length == 1) {
            //====== Has One member
            this.memberCheckedObj = response.data[0];
            if (response.data[0].memberpackage.length == 1) {
              //====== If has one active package then perform checkin check.
              this.performCheckin(response.data[0].memberpackage[0]);
            } else if (response.data[0].memberpackage.length > 1) {
              this.hasMultiplePackages = true;
            }
          } else {
            //------ Has many members

            this.memberResult = response.data;
            this.hasMultipleResults = true;
          }

          //console.log(response.data.data);
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loadingSearch = false;
        });
    },
    verifyMemberPackage(member) {
      this.memberCheckedObj = member;
      this.hasMultipleResults = false;

      if (this.memberCheckedObj.memberpackage.length == 0) {
      } else if (this.memberCheckedObj.memberpackage.length == 1) {
        this.performCheckin(this.memberCheckedObj.memberpackage[0]);
      } else {
        this.hasMultiplePackages = true;
      }

      //this.hasMultipleResults = false;

      /*       this.performCheckin(this.memberCheckedObj.memberpackage[0]);

      if (
        this.memberCheckedObj != null &&
        this.memberCheckedObj.memberpackage.length == 1 &&
        this.memberCheckedObj.status == "ACTIVE"
      ) {
        //=== If member has 1 active package then select it.
        //this.memberPackageCheckedObj = this.memberCheckedObj.memberpackage[0];
        this.performCheckin(this.memberCheckedObj.memberpackage[0]);
        //console.log(this.memberPackageCheckedObj[0]);
      } else {
        //=== If member has 0 or many active packages then do not select them yet.
        this.memberPackageCheckedObj = null;
      } */

      /*
      this.timeout = setTimeout(() => {
        this.clearMember();
      }, 10000);*/
    },
    async performCheckin(memberpackage) {
      let self = this;
      //console.log(memberpackage);
      this.loadingCheckin = true;
      this.hasMultiplePackages = false;
      await axios
        .post("/api/members/checkin", {
          memberid: memberpackage.member_id,
          memberpackageid: memberpackage.id
        })
        .then(response => {
          //console.log(554645654);
          //console.log("len " + response.data.data.length);
          //console.log(response.data);
          //console.log(response.data.bookings);
          if (response.data.schedules != null) {
            self.schedules = response.data.schedules;
            /* var bkarr = {};
            for (var i = 0; i < response.data.schedules.length; i++) {
              bkarr[response.data.schedules[i].id] = {};
              for (
                var j = 0;
                j < response.data.schedules[i].bookings.length;
                j++
              ) {
                var bkarrmem =
                  bkarr[response.data.schedules[i].id][
                    response.data.schedules[i].bookings[j].member_id
                  ];

                 if (bkarrmem == null) {
                  bkarrmem = {};
                  bkarrmem.push(response.data.schedules[i].bookings[j]);
                } else {
                  bkarrmem.push(response.data.schedules[i].bookings[j]);
                } 

                //console.log(response.data.schedules[i].bookings[j]);
              }
            }
            console.log(bkarr); */
          }

          this.afterchk_session_use = response.data.session_use;
          this.afterchk_session_max = response.data.session_max;

          self.isActivePackage = true;
          self.memberPackageCheckedObj = memberpackage;
          //console.log(self.memberPackageCheckedObj);
        })
        .catch(function(error) {
          //console.log(8888888);
          //console.log(error.response.data.errors);
          //if(error.response.data.errors.message =)
          if (422 === error.response.status) {
            self.isExpirePackage = true;
          }
          self.isActivePackage = false;
          self.memberPackageCheckedObj = null;
        })
        .finally(() => {
          this.loadingCheckin = false;
          this.timeout = setTimeout(() => {
            this.resetSearch();
          }, 30000);
        });
    },
    classcheckin(schedule, event) {
      this.checkinloading = true;
      axios
        .post("/api/classes/addorcheckinmember", {
          membercardid: this.memberCheckedObj.cardid,
          memberpackageid: this.memberPackageCheckedObj.id,
          scheduleid: schedule.id,
          checkin: true
        })
        /*         .post("/api/classes/checkinclass", {
          bookingid: booking.id,
          memberpackageid: this.memberPackageCheckedObj.id,
          ischeck: event.target.checked
        }) */
        .then(response => {
          //console.log(response.data);
          //this.members = response.data;
        })
        .finally(() => {
          this.checkinloading = false;
        });
    },
    clearMember() {
      this.memberCheckedObj = null;
      //this.hasMultipleResults = false;
      //this.memberSearchInput = null;
    },
    getLocalPackageFull(p) {
      return getPackageFull(p.type + " " + p.duration);
    },
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    }
  }
};
</script>
<style scoped>
#searchbtt {
  cursor: pointer;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1, 0, 0, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.red {
  color: maroon;
}
.checkinbox {
  width: 20px;
  height: 20px;
}
.classcard {
  color: #000;
}
</style>
